import React, { useEffect, useState, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog, faUserTag } from '@fortawesome/free-solid-svg-icons'

import Sites from './Sites'
import Imports from '../../Realtime/Imports'
import Tabs from '../../utils/Tabs'
import Admin from '../../Admin/Facilities/Show'
import AdminRequests from '../../Admin/Facilities/ShowRequests'

const Content = ({ tab }) => {
  const facility = useSelector(store => store.facilities.facility)
  const [contentActive, setContentActive] = useState('sites')
  const adminUser = useSelector(store => store.user.admin)

  const tabOptions = useMemo(
    () => [
      ...(adminUser
        ? [
            {
              name: <FontAwesomeIcon icon={faCog} />,
              value: 'admin'
            },
            {
              name: <FontAwesomeIcon icon={faUserTag} />,
              value: 'adminRequests'
            }
          ]
        : []),

      {
        name: 'Sites',
        value: 'sites'
      },
      {
        name: 'Import History',
        value: 'imports'
      }
    ],
    [adminUser]
  )

  useEffect(() => {
    if (tab === 'a') {
      setContentActive('imports')
    }
  }, [tab])

  return (
    <div className="mt-4">
      <Tabs large options={tabOptions} active={contentActive} onChange={setContentActive} />
      {contentActive === 'admin' && <Admin />}
      {contentActive === 'adminRequests' && <AdminRequests />}
      {contentActive === 'sites' && <Sites />}
      {contentActive === 'imports' && <Imports short facilityId={facility.id} />}
    </div>
  )
}

export default Content
